<template>
  <div class="page-shell home-mode">
    <div class="home-ambient home-ambient-left"></div>
    <div class="home-ambient home-ambient-right"></div>

    <div class="app-shell">
      <AppSidebar />

      <main class="home-shell">
      <header class="home-topbar">
        <div class="topbar-brand">
          <img
            class="logo"
            src="/image/logo.png"
            alt="兔灵智绘"
          >
          <div>
            <p class="topbar-label">我的课程空间</p>
            <h1>欢迎回来，{{ profile.name }}</h1>
          </div>
        </div>

        <div class="topbar-actions">
          <button class="topbar-button muted" type="button">我的课堂</button>
          <button class="topbar-button" type="button" :disabled="logoutLoading" @click="handleLogout">
            {{ logoutLoading ? '退出中...' : '退出登录' }}
          </button>
          <div class="profile-chip">
            <div class="avatar-glow"></div>
            <div>
              <strong>{{ profile.name }}</strong>
              <span>{{ profile.org }}</span>
            </div>
          </div>
        </div>
      </header>

      <section class="hero-grid">
        <article class="hero-card main-hero">
          <div class="hero-kicker">课程进度</div>
          <div class="hero-main">
            <div class="hero-course-cover" :style="featuredCoverStyle">
              <div class="cover-badge">推荐课程</div>
            </div>
            <div class="hero-course-copy">
              <p class="hero-section-title">当前推荐</p>
              <h2>{{ featuredCourse.title }}</h2>
              <p>{{ featuredCourse.description }}</p>
              <div class="hero-meta-row">
                <div>
                  <span>课程总数</span>
                  <strong>{{ stats.courseCount }}</strong>
                </div>
                <div>
                  <span>已开通</span>
                  <strong>{{ stats.openCourseCount }}</strong>
                </div>
                <div>
                  <span>当前用户</span>
                  <strong>{{ profile.shortLabel }}</strong>
                </div>
              </div>
            </div>
          </div>
        </article>

        <article class="hero-card side-hero">
          <div class="side-hero-avatar"></div>
          <div class="side-hero-copy">
            <p class="hero-kicker">学习档案</p>
            <h3>{{ profile.name }}</h3>
            <p>{{ profile.org }}</p>
          </div>
          <div class="side-hero-points">
            <span>当前积分</span>
            <strong>{{ profile.pointsLabel }}</strong>
          </div>
          <div class="badge-row">
            <span class="mini-badge">课程 {{ stats.courseCount }}</span>
            <span class="mini-badge">作品 {{ stats.works }}</span>
            <span class="mini-badge">已完成 {{ stats.completedCourseCount }}</span>
          </div>
        </article>
      </section>

      <section class="panel-row">
        <div class="section-heading">
          <div>
            <p class="section-eyebrow">Courses</p>
            <h2>课程模块</h2>
          </div>
        </div>

        <div class="card-grid">
          <article v-for="course in courses" :key="course.id" class="course-card">
            <div class="course-visual" :style="resolveCourseVisual(course)">
              <span class="course-status">{{ course.statusText }}</span>
            </div>
            <div class="course-body">
              <p class="course-meta">共 {{ course.chapterCount }} 节课</p>
              <h3>{{ course.title }}</h3>
              <p class="course-desc">{{ course.description }}</p>
              <button type="button" class="card-link" @click="handleCourseClick(course)">
                {{ isLockedCourse(course) ? "加入课程" : "查看详情" }}
              </button>
            </div>
          </article>
        </div>
      </section>

      </main>

      <div
        v-if="joinDialog.visible && joinDialog.course"
        class="studio-lightbox"
        @click.self="closeJoinDialog"
      >
        <div class="studio-lightbox-panel join-course-dialog">
          <div class="join-course-dialog-copy">
            <p class="eyebrow">加入课程</p>
            <h2>{{ joinDialog.course.title }}</h2>
            <p>当前课程尚未开通，加入课程后才可以查看课程详情和课节内容。现在加入吗？</p>
          </div>

          <div class="join-course-dialog-actions">
            <button
              type="button"
              class="topbar-button muted"
              :disabled="joinLoading"
              @click="closeJoinDialog"
            >
              取消
            </button>
            <button
              type="button"
              class="topbar-button"
              :disabled="joinLoading"
              @click="confirmJoinCourse"
            >
              {{ joinLoading ? "加入中..." : "加入并查看" }}
            </button>
          </div>

          <p v-if="joinError" class="status-text error join-course-dialog-error">
            {{ joinError }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppSidebar from "../components/AppSidebar.vue";
import { getCourseDashboard, joinCourse } from "../api/course";
import { getCurrentUser, logout, refreshToken } from "../api/auth";
import { clearCourseDashboard, saveCourseDashboard } from "../utils/course-dashboard";
import { clearAuthState, readAuthState, saveAuthState } from "../utils/auth";

export default {
  name: "HomeView",
  components: {
    AppSidebar: AppSidebar
  },
  data: function data() {
    return {
      authLoading: true,
      dashboardLoading: true,
      logoutLoading: false,
      dashboardError: "",
      joinLoading: false,
      joinError: "",
      auth: readAuthState(),
      stats: createEmptyStats(),
      featuredCourse: createEmptyCourse(),
      courses: [],
      joinDialog: {
        visible: false,
        course: null
      }
    };
  },
  computed: {
    profile: function profile() {
      var user = this.auth.user || {};
      var email = user.email || "已登录用户";
      var pointsBalance = Number(user.points_balance || 0);
      return {
        name: user.name || "未命名用户",
        org: email,
        shortLabel: (user.name || email || "USER").slice(0, 8),
        points: pointsBalance,
        pointsLabel: formatNumber(pointsBalance)
      };
    },
    featuredCoverStyle: function featuredCoverStyle() {
      if (this.featuredCourse.coverUrl) {
        return {
          backgroundImage: "url(" + this.featuredCourse.coverUrl + ")",
          backgroundSize: "cover",
          backgroundPosition: "center"
        };
      }

      return {
        background: this.featuredCourse.cover
      };
    }
  },
  created: function created() {
    this.bootstrapAuth();
  },
  methods: {
    async bootstrapAuth() {
      this.authLoading = true;
      this.auth = readAuthState();

      if (!this.auth.accessToken) {
        this.$router.replace({ name: "login" });
        return;
      }

      try {
        var user = await getCurrentUser(this.auth.accessToken);
        this.auth = saveAuthState({
          accessToken: this.auth.accessToken,
          tokenType: this.auth.tokenType,
          expiresIn: this.auth.expiresIn,
          user: user
        });
        await this.fetchDashboard();
      } catch (error) {
        if (error.status === 401) {
          var refreshed = await this.tryRefresh();
          if (!refreshed) {
            this.resetAuth();
          }
        } else {
          this.dashboardError = error.message || "初始化用户信息失败。";
          this.resetAuth();
        }
      } finally {
        this.authLoading = false;
      }
    },
    async tryRefresh() {
      if (!this.auth.accessToken) {
        return false;
      }

      try {
        var payload = await refreshToken(this.auth.accessToken);
        this.auth = saveAuthState({
          accessToken: payload.access_token,
          tokenType: payload.token_type,
          expiresIn: payload.expires_in,
          user: payload.user
        });
        await this.fetchDashboard();
        return true;
      } catch (error) {
        return false;
      }
    },
    async fetchDashboard() {
      this.dashboardLoading = true;
      this.dashboardError = "";

      try {
        var payload = await getCourseDashboard(this.auth.accessToken);
        var dashboard = unwrapDashboardPayload(payload);
        saveCourseDashboard(dashboard);
        this.stats = normalizeStats(dashboard.stats);
        this.featuredCourse = normalizeCourse(dashboard.featuredCourse);
        this.courses = Array.isArray(dashboard.courses)
          ? dashboard.courses.map(function(course) {
              return normalizeCourse(course);
            })
          : [];
      } catch (error) {
        this.dashboardError = error.message || "课程数据加载失败，请稍后重试。";
        this.stats = createEmptyStats();
        this.featuredCourse = createEmptyCourse();
        this.courses = [];
      } finally {
        this.dashboardLoading = false;
      }
    },
    async handleLogout() {
      this.logoutLoading = true;

      try {
        if (this.auth.accessToken) {
          await logout(this.auth.accessToken);
        }
      } catch (error) {
        // Always clear local auth on logout.
      } finally {
        this.logoutLoading = false;
        this.resetAuth();
      }
    },
    resetAuth: function resetAuth() {
      clearCourseDashboard();
      clearAuthState();
      this.$router.replace({ name: "login" });
    },
    goCourseDetail: function goCourseDetail(id) {
      this.$router.push({
        name: "course-detail",
        params: {
          id: String(id)
        }
      });
    },
    handleCourseClick: function handleCourseClick(course) {
      if (this.isLockedCourse(course)) {
        this.joinError = "";
        this.joinDialog = {
          visible: true,
          course: course
        };
        return;
      }

      this.goCourseDetail(course.id);
    },
    closeJoinDialog: function closeJoinDialog() {
      if (this.joinLoading) {
        return;
      }

      this.joinError = "";
      this.joinDialog = {
        visible: false,
        course: null
      };
    },
    async confirmJoinCourse() {
      var course = this.joinDialog.course;

      if (!course || !course.id || this.joinLoading) {
        return;
      }

      this.joinLoading = true;
      this.joinError = "";

      try {
        var payload = await joinCourse(course.id, this.auth.accessToken);
        this.applyJoinResult(course.id, unwrapJoinPayload(payload));
        await this.fetchDashboard();
        this.closeJoinDialog();
        this.goCourseDetail(course.id);
      } catch (error) {
        if (error.status === 401) {
          var refreshed = await this.tryRefresh();
          if (!refreshed) {
            this.resetAuth();
            return;
          }

          try {
            var retryPayload = await joinCourse(course.id, this.auth.accessToken);
            this.applyJoinResult(course.id, unwrapJoinPayload(retryPayload));
            await this.fetchDashboard();
            this.closeJoinDialog();
            this.goCourseDetail(course.id);
          } catch (retryError) {
            this.joinError = retryError.message || "加入课程失败，请稍后重试。";
          }
        } else {
          this.joinError = error.message || "加入课程失败，请稍后重试。";
        }
      } finally {
        this.joinLoading = false;
      }
    },
    applyJoinResult: function applyJoinResult(courseId, payload) {
      var joinData = payload || {};
      var nextStatus = joinData.status || "opened";
      var nextStatusText = joinData.statusText || "已开通";

      this.courses = this.courses.map(function(course) {
        if (String(course.id) !== String(courseId)) {
          return course;
        }

        return Object.assign({}, course, {
          status: nextStatus,
          statusText: nextStatusText
        });
      });

      if (String(this.featuredCourse.id) === String(courseId)) {
        this.featuredCourse = Object.assign({}, this.featuredCourse, {
          status: nextStatus,
          statusText: nextStatusText
        });
      }
    },
    isLockedCourse: function isLockedCourse(course) {
      return !!course && String(course.status || "").toLowerCase() === "locked";
    },
    resolveCourseVisual: function resolveCourseVisual(course) {
      if (course.coverUrl) {
        return {
          backgroundImage: "url(" + course.coverUrl + ")",
          backgroundSize: "cover",
          backgroundPosition: "center"
        };
      }

      return {
        background: course.cover
      };
    }
  }
};

function unwrapDashboardPayload(payload) {
  if (payload && payload.data && typeof payload.data === "object") {
    return payload.data;
  }

  return payload || {};
}

function unwrapJoinPayload(payload) {
  if (payload && payload.data && typeof payload.data === "object") {
    return payload.data;
  }

  return payload || {};
}

function createEmptyStats() {
  return {
    courseCount: 0,
    openCourseCount: 0,
    completedCourseCount: 0,
    works: 0
  };
}

function createEmptyCourse() {
  return {
    id: 0,
    title: "暂无课程",
    description: "课程数据将在接口返回后显示。",
    chapterCount: 0,
    status: "pending",
    statusText: "等待加载",
    coverUrl: "",
    cover: "linear-gradient(160deg, #d9cbff 0%, #9b79ff 48%, #5f33dd 100%)"
  };
}

function normalizeStats(payload) {
  var source = payload || {};
  return {
    courseCount: Number(source.courseCount || 0),
    openCourseCount: Number(source.openCourseCount || 0),
    completedCourseCount: Number(source.completedCourseCount || 0),
    works: Number(source.works || 0)
  };
}

function normalizeCourse(payload) {
  var source = payload || {};
  return {
    id: source.id || 0,
    title: source.title || "未命名课程",
    description: source.description || "",
    chapterCount: Number(source.chapterCount || 0),
    status: source.status || "not_started",
    statusText: source.statusText || "未开始",
    coverUrl: normalizeCoverUrl(source.coverUrl || ""),
    cover: "linear-gradient(160deg, #d9cbff 0%, #9b79ff 48%, #5f33dd 100%)"
  };
}

function normalizeCoverUrl(url) {
  if (!url) {
    return "";
  }

  if (url.indexOf("http://aicreator.com/") === 0) {
    return url.replace("http://aicreator.com/", "https://aicreator.com/");
  }

  return url;
}

function formatNumber(value) {
  return Number(value || 0).toLocaleString("zh-CN");
}
</script>
